var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-button",on:{"click":el => !_vm.disabled && _vm.$emit('click', el)}},[_vm._t("default"),(_vm.disabled)?_c('div',{staticClass:"disabled"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }